// extracted by mini-css-extract-plugin
module.exports = {"platforms":"Platforms-styles-module--platforms--dnymF"};